import React from "react";
import PatientRelease from "./PatientRelease";
import StaffRelease from "./StaffRelease";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";

function AddRelease() {
  return (
    <div className="space-y-3">
      {/* Header */}
      <div className="bg-white rounded-[8px] shadow-lg shadow-slate-200/50 border border-slate-100 p-3">
        <div className="flex items-center gap-2">
          <div className="w-7 h-7 bg-emerald-100 rounded-md flex items-center justify-center">
            <LocalShippingIcon className="text-emerald-600" sx={{ fontSize: 14 }} />
          </div>
          <div>
            <h2 className="text-xs font-bold text-slate-800">Add Product Release</h2>
            <p className="text-[10px] text-slate-500">Release products to patients or staff</p>
          </div>
        </div>
      </div>

      {/* Release Forms */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-3">
        <PatientRelease />
        <StaffRelease />
      </div>
    </div>
  );
}

export default AddRelease;